module.exports = __webpack_public_path__ + "img/tank-base-1.e5fc736b.png";